export default __webpack_public_path__ + "72eccd8f86a7443a4d67eda07c0b7b41.png";